import { render, staticRenderFns } from "./WaMessageIndex.vue?vue&type=template&id=7779bd7c&scoped=true&"
import script from "./WaMessageIndex.vue?vue&type=script&lang=js&"
export * from "./WaMessageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7779bd7c",
  null
  
)

export default component.exports